/** Тип скидки. */
export enum DiscountType {
    /** Проценты. */
    Percent = "percent",

    /** Фиксированная сумма. */
    Fixed = "fixed",
}
